import { render, staticRenderFns } from "./ResultsList.vue?vue&type=template&id=2566e0ce&scoped=true&"
import script from "./ResultsList.vue?vue&type=script&lang=js&"
export * from "./ResultsList.vue?vue&type=script&lang=js&"
import style0 from "./ResultsList.vue?vue&type=style&index=0&id=2566e0ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2566e0ce",
  null
  
)

component.options.__file = "ResultsList.vue"
export default component.exports